<template>
  <div>
    <div class="home-special-fund-list" v-if="screenWidth > 540">
      <div v-if="screenWidth > 540" @click="toDetails(item.id)" v-for="(item, index) in specialFundList.filter((listItem, i) => i >= 4*page && i<4*(page+1))" :key="item.id" class="home-special-fund-item" :style="{'background-image': 'url('+item.imgUrl+')',}">
        <div class="home-special-fund-title">
          {{ item.name }}
        </div>
      </div>
      <div v-if="screenWidth <= 540" @click="toDetails(item.id)" v-for="(item, index) in specialFundList.filter((listItem, i) => i >= 2*page && i<2*(page+1))" :key="item.id" class="home-special-fund-item2" :style="{'background-image': 'url('+item.imgUrl+')',}">
        <div class="home-special-fund-title">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="home-special-fund-bottom" v-if="screenWidth > 540">
      <div class="bottom-progress">
        <div class="bottom-progress-red" :class="page == 0?'bottom-progress-red-left':'bottom-progress-red-right'"></div>
      </div>
      <div class="bottom-pagination">
        <i class="el-icon-arrow-left" @click="changePage('pre')"></i> <i class="el-icon-arrow-right" @click="changePage('next')"></i>
      </div>

    </div>

    <div style="width:100%;overflow: auto;padding:0 2rem;box-sizing:border-box;overflow: scroll;" v-if="screenWidth<=540">
      <el-row :gutter="20" style="margin-top: 3rem; width:290vw;">
        <el-col :span="6" v-for="(item, index) in specialFundList.filter((listItem, i) => i >= 4*page && i<4*(page+1))" :key="item.id">
          <div style="width:100%;" @click="toDetails(item.id)">
            <img :src="item.imgUrl" alt="" class="special-fund-card-img">
          </div>
          <div class="special-fund-card-text">
            <div class="home-special-fund-title">
              {{ item.name }}

            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['screenWidth'])
  },
  props: {
    specialFundList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      page: 0
    }
  },
  methods: {
    changePage(type) {
      if (type === 'pre') {
        this.page = 0
      } else {
        this.page = 1
      }
    },
    toDetails(id) {
      const routeUrl = this.$router.resolve({
        path: '/specialFundDetails',
        query: {
          id: id
        }
      })
      window.open(routeUrl.href, "_blank")
    }
  },
}
</script>
<style lang="less" scoped>
#swipercom {
  width: 100%;
  .swiper-container {
    width: 100%;
    border-radius: 5px;
    padding-bottom: 2.5rem;
  }
  .swiper-slide {
    text-align: center;
    // margin: 0 -20px;
    position: relative;
    img {
      width: 18rem;
      height: 20rem;
      border-radius: 5px;
    }
    .back{
      position: absolute;
      bottom: 0;
      left: 20px;
      z-index: 99999999999;
      bottom: 0;
      left: 0;
      color: white;
      padding: 10px;
      width: 100%;
      
      div {
        font-size: 1.2rem;
        font-weight: 600;
        color: #ffffff;
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        bottom: 1rem;
        text-shadow: -0.05rem -0.05rem #757373, 0.05rem 0.05rem #757373;
        padding: 0 1rem;
        
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .swiper-pagination {
  }
  ::v-deep .swiper-pagination-bullet {
    width: 25px;
    height: 3px;
    border-radius: 5px;
  }
}


.home-special-fund-list {
  width: 95%;
  margin: 0 auto;
  overflow: auto;
}
.home-special-fund-item {
  width: 23%;
  height: 24rem;
  margin: 2rem 1%;
  float: left;
  box-sizing: border-box;
  border-radius: 0.3rem;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .home-special-fund-title {
    font-size: 1.0rem;
    font-weight: 600;
    color: rgb(255, 255, 255);
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    position: absolute;
    bottom: 1rem;
    text-shadow: -0.05rem -0.05rem #757373, 0.05rem 0.05rem #757373;
    padding: 0 1rem;
    white-space: nowrap; /* 禁止文字换行 */
    overflow: hidden; /* 隐藏超出容器宽度的部分 */
    text-overflow: ellipsis;
    // .highlight{
    //   background-color: rgba(92, 88, 88, 0.6);
    // }
  }
}

.home-special-fund-item2 {
  width: 42.5%;
  height: 10rem;
  margin: 2rem 3%;
  float: left;
  box-sizing: border-box;
  border-radius: 0.3rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  .home-special-fund-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: rgb(255, 255, 255);
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    position: absolute;
    bottom: 1rem;
    text-shadow: -0.05rem -0.05rem #757373, 0.05rem 0.05rem #757373;
    padding: 0 1rem;
    white-space: nowrap; /* 禁止文字换行 */
    overflow: hidden; /* 隐藏超出容器宽度的部分 */
    text-overflow: ellipsis;
    // .highlight{
    //   background-color: rgba(92, 88, 88, 0.6);
    // }
  }
}
.home-special-fund-item:hover {
  width: 23%;
  height: 26rem;
  margin: 1rem 1%;
}
.home-special-fund-item2:hover {
  width: 44%;
  height: 12rem;
  margin: 1rem 1.5%;
}
.home-special-fund-bottom {
  height: 3rem;
  width: 90%;
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .bottom-progress {
    width: 20%;
    height: 0.6rem;
    border-radius: 0.3rem;
    background-color: #ededed;
    .bottom-progress-red {
      width: 50%;
      height: 0.5rem;
      border-radius: 0.3rem;
      background-color: red;
    }
  }
}
.bottom-progress-red-left {
  float: left;
}
.bottom-progress-red-right {
  float: right;
}
div::-webkit-scrollbar {
  display: none;
}

.special-fund-card-img {
  width: 100%;
}
.special-fund-card-img::hover {
  width: 105%;
}
.special-fund-card-text {
  position: relative;
  .home-special-fund-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: rgb(255, 255, 255);
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    position: absolute;
    bottom: 1.5rem;
    text-shadow: -0.05rem -0.05rem #757373, 0.05rem 0.05rem #757373;
    padding: 0 1rem;
    white-space: nowrap; /* 禁止文字换行 */
    overflow: hidden; /* 隐藏超出容器宽度的部分 */
    text-overflow: ellipsis;
    // .highlight{
    //   background-color: rgba(92, 88, 88, 0.6);
    // }
  }
}
</style>